module.exports = __webpack_public_path__ + "img/flight-IU-super-airjet-circle.f6905548.svg";